function removeHTMLTags(str) {
  return (str && str.replace(/<\/?[^>]+(>|$)/g, "")) || null;
}

export default removeHTMLTags;
